export default __webpack_public_path__ + "pdf/Garavan Institute Offer May 2015.87ede8f.pdf";